module.exports = __webpack_public_path__ + "static/media/csv.2a3b15ed.svg";